import { captureException, SeverityLevel, withScope } from '@sentry/react';
import { sessionIdStorage } from '@orionprotocol/common';

export type { SeverityLevel };

export function reportToSentry(
  error: unknown,
  context: Partial<Record<string, unknown>> = {},
  level: SeverityLevel = 'error',
): void {
  withScope((scope) => {
    scope.setLevel(level);
    scope.setExtras({
      ...context,
      sessionId: sessionIdStorage.getSessionId(),
    });
    captureException(error);
  });
}
